import api from './api'

/**
 * 检查订单状态
 *
 * @export
 * @param {String} orderId 订单id
 * @return {Promise} 成功为 true, 其他为 false
 */
export default async function checkOrder (orderId) {
  const { data } = await api.PackageEduFePay.status({ orderId })
  return data === 1
}
